__turbopack_context__.v({
  "icon-link": "policy-category-module-scss-module__QA9usq__icon-link",
  "list": "policy-category-module-scss-module__QA9usq__list",
  "list-heading": "policy-category-module-scss-module__QA9usq__list-heading",
  "list-item": "policy-category-module-scss-module__QA9usq__list-item",
  "list-item--title": "policy-category-module-scss-module__QA9usq__list-item--title",
  "policy-category": "policy-category-module-scss-module__QA9usq__policy-category",
  "policy-category--sidebar": "policy-category-module-scss-module__QA9usq__policy-category--sidebar",
});
